module.exports = __webpack_public_path__ + "img/hwc_img2.56e3d134.jpg";